import { supabase } from "@/lib/supabase";
import { DOMAIN_ERROR_CODES, DomainError, throwOnSupabaseError } from "@/utils/errors";
import analytics from "@/lib/Analytics";

export const invokeApi = {
  upgradeSubscription: async () => {
    analytics.track("Upgrade to Advanced Plan Started");
    
    const { data, error } = await supabase.functions.invoke('upgrade-subscription');

    throwOnSupabaseError(error);

    if (data == null) {
      throw new DomainError(
        DOMAIN_ERROR_CODES.VALIDATION_FAILED,
        "Empty response from upgrade-subscription",
      );
    }

    if (data.error) {
      throw new DomainError(
        DOMAIN_ERROR_CODES.VALIDATION_FAILED,
        data.error,
      );
    }

    analytics.track("Upgrade to Advanced Plan Success", { new_plan: data.new_plan });

    return data.new_plan;
  },
}